import React from "react";
import Icon from "../../../components/AppIcon";
import Image from "../../../components/AppImage";

const PartnerTestimonials = () => {
  const testimonials = [
    {
      id: 1,
      partner: "Microsoft",
      representative: "Sarah Mitchell",
      position: "Partner Development Manager",
      avatar:
        "https://img.rocket.new/generatedImages/rocket_gen_img_1ca693890-1763293865080.png",
      avatarAlt:
        "Professional headshot of Caucasian woman with shoulder-length brown hair wearing navy blue blazer and white blouse smiling confidently",
      quote:
        "Orator Hype has consistently demonstrated exceptional technical expertise and customer commitment. Their Azure implementations showcase deep understanding of enterprise cloud architecture and security best practices. A true Gold Partner in every sense.",
      rating: 5,
      collaboration: "5+ years",
      projects: "87+",
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_145384e6b-1764682770253.png",
      logoAlt:
        "Microsoft logo with four colored squares in red green blue and yellow on white background representing technology partnership",
    },
    {
      id: 2,
      partner: "Zoho",
      representative: "Rajesh Kumar",
      position: "Strategic Partnerships Lead",
      avatar:
        "https://img.rocket.new/generatedImages/rocket_gen_img_12b9c2bb3-1763293370864.png",
      avatarAlt:
        "Professional headshot of Indian man with short black hair wearing charcoal gray suit and light blue shirt with warm smile",
      quote:
        "Working with Orator Hype has been transformative for our joint clients. Their ability to customize Zoho solutions while maintaining platform integrity is remarkable. They understand both technology and business needs perfectly.",
      rating: 5,
      collaboration: "4+ years",
      projects: "64+",
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1ca85fe53-1766763600433.png",
      logoAlt:
        "Zoho logo with distinctive orange and white branding on modern digital interface representing business software partnership",
    },
    {
      id: 3,
      partner: "Acronis",
      representative: "Elena Volkov",
      position: "Elite Partner Program Director",
      avatar:
        "https://img.rocket.new/generatedImages/rocket_gen_img_1b24a7c2e-1763296129552.png",
      avatarAlt:
        "Professional headshot of Eastern European woman with blonde hair in elegant black blazer with confident professional demeanor",
      quote:
        "Orator Hype's cybersecurity implementations set the industry standard. Their comprehensive approach to data protection and disaster recovery has helped numerous enterprises achieve complete peace of mind. Outstanding technical proficiency.",
      rating: 5,
      collaboration: "3+ years",
      projects: "52+",
      logo: "https://img.rocket.new/generatedImages/rocket_gen_img_12a51bdbb-1766763598929.png",
      logoAlt:
        "Acronis cybersecurity shield logo in teal and black representing data protection and backup solutions partnership",
    },
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8 bg-background">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <div className="inline-flex items-center gap-2 bg-accent/10 px-4 py-2 rounded-full mb-4">
            <Icon name="MessageSquare" size={18} color="var(--color-accent)" />
            <span className="text-accent text-sm font-medium">
              Partner Voices
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4">
            What Our Partners Say
          </h2>
          <p className="text-text-secondary text-sm md:text-base lg:text-lg max-w-3xl mx-auto">
            Testimonials from technology partner representatives highlighting
            collaboration quality, technical expertise, and mutual success in
            delivering enterprise solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {testimonials?.map((testimonial) => (
            <div
              key={testimonial?.id}
              className="bg-card rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col"
            >
              <div className="bg-gradient-to-br from-primary/5 to-secondary/5 p-6 md:p-8 border-b border-border">
                <div className="flex items-center justify-between mb-6">
                  <div className="w-16 h-16 rounded-xl overflow-hidden shadow-md">
                    <Image
                      src={testimonial?.logo}
                      alt={testimonial?.logoAlt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex gap-1">
                    {[...Array(testimonial?.rating)]?.map((_, index) => (
                      <Icon
                        key={index}
                        name="Star"
                        size={16}
                        color="var(--color-warning)"
                        fill="var(--color-warning)"
                      />
                    ))}
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 rounded-full overflow-hidden shadow-md flex-shrink-0">
                    <Image
                      src={testimonial?.avatar}
                      alt={testimonial?.avatarAlt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <h3 className="text-base md:text-lg font-bold text-foreground">
                      {testimonial?.representative}
                    </h3>
                    <p className="text-xs md:text-sm text-text-secondary">
                      {testimonial?.position}
                    </p>
                    <p className="text-xs text-primary font-medium mt-1">
                      {testimonial?.partner}
                    </p>
                  </div>
                </div>
              </div>

              <div className="p-6 md:p-8 flex-1 flex flex-col">
                <div className="mb-6 flex-1">
                  <Icon
                    name="Quote"
                    size={32}
                    color="var(--color-primary)"
                    className="mb-4 opacity-20"
                  />
                  <p className="text-sm md:text-base text-text-secondary leading-relaxed">
                    {testimonial?.quote}
                  </p>
                </div>

                <div className="grid grid-cols-2 gap-4 pt-6 border-t border-border">
                  <div className="text-center">
                    <div className="flex items-center justify-center gap-2 mb-2">
                      <Icon
                        name="Calendar"
                        size={16}
                        color="var(--color-secondary)"
                      />
                      <span className="text-xs text-text-secondary">
                        Collaboration
                      </span>
                    </div>
                    <div className="text-base md:text-lg font-bold text-foreground">
                      {testimonial?.collaboration}
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="flex items-center justify-center gap-2 mb-2">
                      <Icon
                        name="Briefcase"
                        size={16}
                        color="var(--color-secondary)"
                      />
                      <span className="text-xs text-text-secondary">
                        Joint Projects
                      </span>
                    </div>
                    <div className="text-base md:text-lg font-bold text-foreground">
                      {testimonial?.projects}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 md:mt-16 bg-gradient-to-r from-primary/10 via-secondary/10 to-accent/10 rounded-2xl p-6 md:p-8 lg:p-12">
          <div className="text-center">
            <Icon
              name="Award"
              size={48}
              color="var(--color-primary)"
              className="mx-auto mb-6"
            />
            <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground mb-4">
              Recognized Excellence in Partnership
            </h3>
            <p className="text-sm md:text-base text-text-secondary max-w-2xl mx-auto mb-8">
              Our commitment to technical excellence, customer success, and
              collaborative innovation has earned recognition from every
              technology partner we work with.
            </p>
            <div className="flex flex-wrap justify-center gap-4 md:gap-6 lg:gap-8">
              <div className="flex items-center gap-2">
                <Icon
                  name="CheckCircle2"
                  size={20}
                  color="var(--color-accent)"
                />
                <span className="text-sm font-medium text-foreground">
                  100% Partner Satisfaction
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="TrendingUp" size={20} color="var(--color-accent)" />
                <span className="text-sm font-medium text-foreground">
                  Year-over-Year Growth
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="Users" size={20} color="var(--color-accent)" />
                <span className="text-sm font-medium text-foreground">
                  Long-term Relationships
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnerTestimonials;
